module.exports = require("lodash");


//////////////////
// WEBPACK FOOTER
// external "lodash"
// module id = 6
// module chunks = 0